export type View = 'files' | 'overview' | 'domains' | 'dns' | 'messages' | 'console' | 'logger' | 'logs' | 'archive' | 'notifications' | 'settings' | 'users' | 'invitations' | 'zones' | 'api-docs';
export type DomainTab = 'profile' | 'keys' | 'resources';

export type AppRoute = {
  view: View;
  domainId?: string;
  domainTab?: DomainTab;
};

export const VIEW_PATHS: Record<View, string> = {
  files: '/files',
  overview: '/overview',
  domains: '/domains',
  dns: '/dns',
  messages: '/messages',
  console: '/console',
  logger: '/logger',
  logs: '/logs',
  archive: '/archive',
  notifications: '/notifications',
  settings: '/settings',
  users: '/users',
  invitations: '/invitations',
  zones: '/zones',
  'api-docs': '/api-docs',
};

const VIEW_BY_PATH = new Map(Object.entries(VIEW_PATHS).map(([view, path]) => [path, view as View]));
const DOMAIN_TABS = new Set<DomainTab>(['profile', 'keys', 'resources']);

export function parseAppRoute(pathname: string): AppRoute {
  const normalized = normalizePath(pathname);
  const view = VIEW_BY_PATH.get(normalized);
  if (view) return { view };

  const match = normalized.match(/^\/domains\/([^/]+)(?:\/([^/]+))?$/);
  if (match) {
    try {
      const domainId = decodeURIComponent(match[1]);
      const requestedTab = match[2] as DomainTab | undefined;
      return {
        view: 'domains',
        domainId,
        domainTab: requestedTab && DOMAIN_TABS.has(requestedTab) ? requestedTab : 'profile',
      };
    } catch {
      return { view: 'overview' };
    }
  }

  return { view: 'overview' };
}

export function appRoutePath(route: AppRoute): string {
  if (route.view === 'domains' && route.domainId) {
    return `/domains/${encodeURIComponent(route.domainId)}/${route.domainTab ?? 'profile'}`;
  }
  return VIEW_PATHS[route.view];
}

function normalizePath(pathname: string): string {
  if (!pathname || pathname === '/') return '/overview';
  const withoutTrailingSlash = pathname.replace(/\/+$/, '');
  return withoutTrailingSlash || '/overview';
}
